module.exports = __webpack_public_path__ + "img/logo01.dd7ff50e.58f55c5c.png";